module.exports = __webpack_public_path__ + "assets/img/free_33.5d10ba41.png";